// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"146":"38ae7307","541":"38ae7307"}[chunkId] + ".chunk.css";
};